import React from 'react';
import { useIsFreemiumUser } from 'hooks/use-freemium-user/use-freemium-user';
import { useAppUiActions } from 'store/app-ui/use-app-ui-actions';
import { UPGRADE_PLAN_SCREEN } from 'extensions/upgrade-your-plan-dialog';
import { useOpenSupportRequest } from 'features/my-zone/support-requests/components/support-requests-modals/support-modal-manager';
import { BodyText, Link } from '@placer-ui/components';
import styles from './autocomplete-no-results-option.module.scss';

export const AutocompleteNoResultsOption = () => {
    const isFreemiumUser = useIsFreemiumUser();
    const { openUpgradePlanPopup } = useAppUiActions();
    const { openSupportRequest } = useOpenSupportRequest();

    const handleClick = () => {
        if (isFreemiumUser) {
            openUpgradePlanPopup(UPGRADE_PLAN_SCREEN.default);
        } else {
            openSupportRequest({ flowType: 'typeSelection' });
        }
    };

    return (
        <div
            className={styles.optionContentWrapper}
            onClick={handleClick}
            data-testid="no-results-autocomplete-option"
        >
            <BodyText size="default" element="label">
                Can't find what you are looking for?
            </BodyText>
            {/* added onClick to link as well for accessibility (on enter/space) */}
            <Link onClick={handleClick}>{isFreemiumUser ? 'Contact Us' : 'Request location'}</Link>
        </div>
    );
};
